module.exports = __webpack_public_path__ + "static/media/event01.0720c822.jpg";